<template>
    <div class="mb-4">
        <div class="head" data-target="#categorie" data-toggle="collapse" aria-expanded="true">
            <h4>Producten <span class="icon-arrow"></span></h4>
        </div>
        <div class="collapse show" id="categorie">
            <ul v-if="categories && categories.length">
                <li class="filter-list" v-for="categorie in categories" v-bind:key="categorie.categorieId"><a v-bind:class="{ checked: isChecked(categorie.CategorieId) }" v-bind:href="categorie.Url">{{ categorie.Naam }}</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    //data-parent="#accordion"  add to id="categorie"
    export default {
    name: 'CategorieLinks',
        methods: {
            fetchCountries() {
                this.$store.dispatch('fetchCategories');
            },
            isChecked(categorieId) {
                return this.$store.state.categorieId == categorieId;
            }

        },
    created() {
        this.$store.dispatch('fetchCategories');
        this.$store.dispatch('fetchProducts', this.$store.state.checkedFilter);
    },
    computed: {
        categories() {
            return this.$store.state.filtertree.Categories;
        }
    }
    }
</script>